import { Box, Tab, Typography } from '@mui/material';
import { t } from 'i18next';
import { ContactInformation, DetailsCard, Privacy } from './components';
import { useProfile } from './hooks';
import { TabContext, TabList, TabPanel } from '@mui/lab';

export const Profile = () => {
  const { profile, tabIndex, handleChangeTab } = useProfile();

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      <Box
        sx={{
          height: '100%',
          ml: '2rem',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography variant='h4' sx={{ pb: '1.4rem' }}>
          {t('profile.title')}
        </Typography>
        {profile && profile.id ? (
          <DetailsCard profile={profile} />
        ) : (
          <Box>Profile details could not be loaded</Box>
        )}
      </Box>

      <Box
        sx={{
          mb: 2,
          ml: '2rem',
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <TabContext value={tabIndex}>
          <Box>
            <TabList onChange={handleChangeTab}>
              <Tab label='PRIVACY & SECURITY' value='1' />
              <Tab label='CONTACT INFORMATION' value='2' />
            </TabList>
          </Box>
          <TabPanel
            sx={{
              padding: '0 !important',
              mt: '1rem',
              flexGrow: 1,
              width: '100%',
            }}
            value='1'
          >
            {profile && profile.id && <Privacy profile={profile} />}
          </TabPanel>
          <TabPanel
            sx={{
              padding: '0 !important',
              mt: '1rem',
              height: '90%',
              width: '100%',
            }}
            value='2'
          >
            {profile && profile.id && <ContactInformation profile={profile} />}
          </TabPanel>
        </TabContext>
      </Box>
    </Box>
  );
};
